import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, offerChecklist } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ink-850" data-id="element-137" data-mp="307j2a0m3mzx0">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-20" data-id="element-138" data-mp="356cbhgucs4rd">
        <div className="rounded-3xl border-[3px] border-brand-green bg-ink-card p-7 shadow-panel md:p-10" data-id="element-139" data-mp="357nh7m7czml4">
          <h2 id="oferta-title" className="text-center font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-140" data-mp="3a3clg2ubprnr">
            MÉTODO PARA PADRES DE FUTBOLISTAS
          </h2>
          <p className="mt-3 text-center text-sm font-bold tracking-widest text-brand-gold uppercase" data-id="element-141" data-mp="3nwu2ngzjesam">
            100% DIGITAL · 12 CAPÍTULOS + 2 BONOS
          </p>
          <ul className="mt-8 space-y-3" data-id="element-142" data-mp="3sxrllvsdfqd6">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-3" data-id="element-143" data-mp="1q59rfvi0hl8">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-green text-black" data-id="element-144" data-mp="1klqdme3fevsq">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-145" data-mp="1bk0cggjqsihr" />
                </span>
                <span className="text-[15px] text-body" data-id="element-146" data-mp="16m8ilgzjemax">{item}</span>
              </li>)}
          </ul>
          <div className="mt-8 rounded-2xl bg-ink-950 px-6 py-8 text-center" data-id="element-147" data-mp="23awndbm8sd2e">
            <p className="text-lg font-semibold text-subtle line-through" data-id="element-148" data-mp="1z9umkqcofsyb">$50.000</p>
            <p className="mt-1 font-display text-5xl font-black text-white md:text-6xl" data-id="element-149" data-mp="1ujnziuxtcgi6">$19.990</p>
            <span className="mt-4 inline-block rounded-full bg-brand-gold px-4 py-1.5 text-xs font-black uppercase tracking-[0.12em] text-black" data-id="element-150" data-mp="1pkktp8a0e695">
              Oferta de hoy · Solo por hoy
            </span>
          </div>
          <div className="mt-7" data-id="element-151" data-mp="2i8ysvrcu38ma">
            <CtaButton size="xl" fullWidth href={CHECKOUT_URL} data-id="element-152" data-mp="2i7ns80eoqgze">
              Quiero obtener el método ahora
            </CtaButton>
          </div>
          <p className="mt-5 text-center text-sm text-subtle" data-id="element-153" data-mp="364ajk2kdhgwb">
            🔒 Pago seguro · ⚡ Acceso inmediato · 💳 Pago único · ✅ Garantía 7 días
          </p>
          <p className="mt-2 text-center text-xs text-subtle" data-id="element-154" data-mp="2scx4p1xet77m">
            Material 100% digital en PDF: no hay envíos ni mensualidades.
          </p>
        </div>
      </div>
    </section>;
}